import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';

class ActivitiesStackedAreaChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const colors = [];
        const { chartRef } = this;

        this.props.keys.forEach((val, index) => {
            colors.push(this.props.colors[index % this.props.colors.length]);
        });
        colors.reverse();

        this.props.keys.forEach((key, index) => {
            series.push({
                name: key,
                color: colors[index % this.props.colors.length],
                data: helpers.backfill(
                    this.props.data[key].items.map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                    this.props.backfillBuckets
                )
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: 'datetime',
            xAxisLabel: this.props.xAxisLabel
        });

        const yAxis = helpers.yAxisConfig({ yAxisLabel: this.props.yAxisLabel });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration
                }
            },
            area: {
                stacking: 'normal'
            }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title,
                            exportLimit: this.props.exportLimit
                        },
                        chart: {
                            type: 'area',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            }
                        },
                        legend: {
                            enabled: this.props.legend,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(ActivitiesStackedAreaChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/ActivitiesStackedAreaChart.js